import { TicketPercentIcon } from './TicketPercentIcon';

/**
 * author: GreenTurtwig
 * id 297864D0-935F-4EF0-9A2C-28F018544581
 * name ticket-percent
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ticket-percent.svg
 * tags
 */
export const VoucherIcon = TicketPercentIcon;
export default VoucherIcon